import React from 'react';
import styled from 'styled-components';

import { InspirationTheme, getThemeLabel } from '../../lib/inspiration';

const SideBarTheme = ({ theme, selectedTheme, onThemeClick }: {
  theme: InspirationTheme,
  selectedTheme?: InspirationTheme,
  onThemeClick: (theme: InspirationTheme) => void
}) => {
  const label = getThemeLabel(theme);

  return <Wrapper>
    {
      theme === selectedTheme ? <>
        <SelectionIndicator/>
        <SelectedTheme>
          {label}
        </SelectedTheme>
      </> : <Theme onClick={() => onThemeClick(theme)}>{label}</Theme>
    }
  </Wrapper>;
};

const Wrapper = styled.li`
  padding: 0;
  cursor: pointer;
  height: 48px;
`;

const Theme = styled.div`
  padding: 12px 16px 12px 36px;
`;

const SelectionIndicator = styled.div`
  width: 5px;
  height: 50px;
  position: absolute;
  left: 0;
  border-radius: 0 10px 10px 0;
  background: #3BBFD8;
`;

const SelectedTheme = styled(Theme)`
  border-radius: 12px;
  background: var(--sp-highlight-bg-color);
`;

export default SideBarTheme;
